import React from "react";
import { Alignment, FlexBehaviour, Side, Size } from "../../types/system/Layout";
import Utilities from "../../foundation/Utility";

import "./Text.scss";

interface TextProps {
    children?: any;
    inline?: boolean;
    flexBehaviour?: FlexBehaviour;
    className?: string;

    clearanceSide?: Side;
    clearanceSize?: Size;

    bufferSide?: Side;
    bufferSize?: Size;

    alignment?: Alignment;
}

class Text extends React.Component<TextProps> {
    render(): React.ReactNode {
        let classNames = this.props.className ? ` ${this.props.className}` : "";

        // Clearance classes
        if (!!this.props.clearanceSide) {
            classNames += ` ${Utilities.getSideClass(
                this.props.clearanceSide,
            )}clearance${Utilities.getSizeClass(this.props.clearanceSize)}`;
        }

        // Buffer classes
        if (!!this.props.bufferSide) {
            classNames += ` ${Utilities.getSideClass(
                this.props.bufferSide,
            )}buffer${Utilities.getSizeClass(this.props.bufferSize)}`;
        }

        // Alignment classes
        if (!!this.props.alignment) {
            classNames += ` text-${this.props.alignment}`;
        }

        switch (this.props.flexBehaviour) {
            case "min":
                classNames += " col-pane";
                break;
            case "max":
                classNames += " col";
                break;
            case "center":
                classNames += " center-pane";
                break;
        }

        if (this.props.inline) classNames += " inline";

        return <div className={`text-container${classNames}`}>{this.props.children}</div>;
    }
}

export default Text;
